<template>
    <CRow>
        <CCol col>
            <div class="col-lg-12 control-section" style="padding:10px;position:relative;">
                <div style="width:100%;">
                    <ejs-grid ref='grid' id="deadlineAlertGridId" :dataSource="data" :allowFiltering='true' :commandClick='commandClick'
                              :allowPaging="true" :allowTextWrap='true' :textWrapSettings='wrapSettings' :allowResizing='true' 
                              :toolbarClick='toolbarClick' :allowExcelExport='true' :excelExportComplete='excelExportComplete' 
                              :allowReordering='true' :allowSorting='true' :editSettings='editSettings' :toolbar='toolbar' 
                              :pageSettings='pageSettings' :actionComplete='actionComplete' :actionBegin="actionBegin" 
                              :actionFailure="actionFailure" :filterSettings='filterOptions' :queryCellInfo='customiseCell' 
                              :query='gridQuery' width="100%" height="100%">
                        <e-columns>
                            <e-column field='id' headerText='Id' width=120 :isPrimaryKey='true' :visible='false'></e-column>
                            <e-column field='alertDate' headerText='Alert Date' textAlign='Right' :format='dateFormatOptions' type='date' width=150></e-column>
                            <e-column field='alertType' headerText='Alert' width=120></e-column>
                            <e-column field='clientName' headerText='Client' width=210></e-column>
                            <e-column field='stateName' headerText='Country' width=150></e-column>
                            <e-column field='companyName' headerText='Company' width=210></e-column>
                            <e-column field='contractName' headerText='Contract' width=300></e-column>
                            <e-column field='utilityTypeName' headerText='Commodity' width=150 :visible="false"></e-column>
                            <e-column field='tradeablePeriodName' headerText='Period' width=120></e-column>

                            <e-column field='deafaultDeadlineDate' headerText='Default Deadline' textAlign='Right' :format='dateFormatOptions' type='date' width=180></e-column>
                            <e-column field='openVolume' headerText='Open Volume' textAlign='Right' type="number" format="n2" width=180></e-column>
                            <e-column field='alertStatus' headerText='Status' width=120></e-column>
                            <e-column headerText='Actions' width=220 textAlign='left' :commands='commands'></e-column>
                        </e-columns>
                    </ejs-grid>
                </div>
                    <ejs-dialog :buttons='alertDlgButtons' cssClass="greyBackground" ref="alertDialog" id="alertDialogDefDeadline" v-bind:visible="false" :animationSettings='animationSettings' :showCloseIcon='showCloseIcon' :open="dialogOpen" :close="dialogClose" :width="alertWidth" :header="header" :allowDragging="draggable" :position="position">
                        <h5 class="ml-5" id="graphHeader">  {{alertType}} - Default Deadline</h5><br />
                        <label class="mr-5 float-right">Alert issued on : {{alertDate}}</label><br />
                        <br />
                        <label class="ml-5">{{alertText}}</label><br />
                        <br />
                        <div class="row">
                            <div class="column ml-3">
                                <label class="ml-5"><b>Client</b>: {{client}}</label><br />
                                <label class="ml-5"><b>Country</b>: {{country}}</label><br />
                                <label class="ml-5"><b>Utility</b>: {{utility}}</label><br />
                                <label class="ml-5"><b>Company</b>: {{company}}</label><br />
                                <label class="ml-5"><b>Contract Name</b>: {{contractName}}</label><br />
                                <label class="ml-5"><b>Contract ID</b>: {{contractId}}</label><br />
                                <br />
                            </div>
                            <div class="column ml-5">
                                <label class="ml-5"><b>Period</b>: {{watchPeriod}}</label><br />
                                <label class="ml-5"><b>Default Deadline</b>: {{deafaultDeadlineDate}}</label><br />
                                <label class="ml-5"><b>Open Volume</b>: {{openVolume}} %</label><br />
                            </div>
                        </div>
                    </ejs-dialog>
                </div>
</CCol>
    </CRow>
</template>

<script>
    import Vue from "vue";
    import { GridPlugin, Edit, Page, Toolbar, Sort, Filter, Reorder, Resize, ExcelExport, ForeignKey, CommandColumn } from "@syncfusion/ej2-vue-grids";
    import { DialogUtility } from '@syncfusion/ej2-popups';
    import SyncHelper from '../../common/syncfusion';
    import gridOptions from '../../common/gridOptions'
    import urls from '../../common/urls';
    import apis from '../../common/network'
    import { Query } from '@syncfusion/ej2-data';
    import { DialogPlugin } from '@syncfusion/ej2-vue-popups';
    import { ButtonPlugin } from '@syncfusion/ej2-vue-buttons';
    import store from '../../store';
    import moment from 'moment';

    Vue.use(DialogUtility);
    Vue.use(GridPlugin);
    Vue.use(ButtonPlugin);
    Vue.use(DialogPlugin);

    export default {
        props: ['reportContractId', 'clientId', 'reportTradingGroupId'],
        components: {
        },
        data() {
            return {
                // needed because of form being loaded from tab,in such cases this isnt available and store is loaded from import
                store: store,
                // needed for vieweing dialog,initally not there then appears
                showCloseIcon: false,
                alertWidth: '700px',
                position: { X: 'center', Y: 'center' },
                animationSettings: { effect: 'Zoom' },
                alertDlgButtons: [{ click: this.alertDlgBtnClick, buttonModel: { content: 'Dismiss', isPrimary: true } }],
                ShowBtn: true,
                gridQuery: new Query().addParams("contractId", this.reportContractId).addParams("clientId", this.clientId).addParams("tradingGroupId", this.reportTradingGroupId),// when form is loaded from contracts reporting ui, when not it will be undefined
                contractUnits: "",
                alertType: "",
                openVolume: "",
                deafaultDeadlineDate: "",
                alertDate: "",
                client: "",
                country: "",
                utility: "",
                company: "",
                contractName: "",
                contractId: "",
                watchPeriod: "",
                alertText: "",
                type: "",
                wrapSettings: { wrapMode: 'Header' },
                commands: [{
                    buttonOption:
                        { cssClass: 'e-primary', content: 'View' }
                },
                {
                    buttonOption:
                        { cssClass: 'secondary', content: 'Mark as Seen' }
                }],
                dateFormatOptions: { type: 'date', format: 'dd/MM/yyyy' },
                data: SyncHelper.getDataManager("DefaultDeadlineAlert"),
                //pageSettings: gridOptions.pageSettings,
                pageSettings: { pageSizes: [10, 20, 50, 100], pageSize: 10, pageCount: 4 },
                editSettings: {
                    showConfirmDialog: true,
                    showDeleteConfirmDialog: true,
                    allowEditing: false,
                    allowAdding: false,
                    allowDeleting: store.state.permissions["Permissions.Triggers.Delete"],
                    mode: 'Dialog'
                },
                toolbar: ['Delete', 'ExcelExport'],
                editparams: { params: { popupHeight: '300px' } },
                filterOptions: gridOptions.filterSettings,
                draggable: true,
                header: " "
            };
        },
        methods: {
            alertDlgBtnClick: function () {
                this.$refs.alertDialog.hide();
            },
            dialogClose: function () {
                this.ShowBtn = true;
            },
            dialogOpen: function () {
                this.ShowBtn = false;
            },
            commandClick: function (args) {
                var triggerAlertId = args.rowData.id;
                if (args.commandColumn.buttonOption.content == "View") {// clone command button
                    this.loadGraph(args.rowData);
                }
                else if (args.commandColumn.buttonOption.content == "Mark as Seen" || args.commandColumn.buttonOption.content == "Mark as Unseen") {// clone command button
                    this.changeAlertStatus(triggerAlertId, this.$refs.grid);
                 
                }
            },
            changeAlertStatus: function (args,grid) {
                apis.protectedApi.put(`${urls.apiBaseUrl}DefaultDeadlineAlert/UpdateStatus/`, { id: args }).then(it => {
                    grid.refresh();
                }).catch(
                    response => {
                        var message = response.response.data.message != undefined ? response.response.data.message : "Error invoking service,please contact support";
                        gridOptions.errorAlert("Error: " + message);
                    }
                );      
            },
            loadGraph: function (args) {
         
                if (args.alertType == "Missed") {
                    document.getElementById('graphHeader').classList.remove('approachingDeadlineHeader');
                    document.getElementById('graphHeader').classList.add('missedDeadlineHeader');
                }
                else {
                    document.getElementById('graphHeader').classList.remove('missedDeadlineHeader');
                    document.getElementById('graphHeader').classList.add('approachingDeadlineHeader');
                }
                //this.type = args.type;
                this.alertText = args.alertType == "Missed" ? "You have missed the hedging deadline for the period. The remaining Open Volume has defaulted. " :
                    "The Deafult Deadline for the period is approaching. The remaining Open Volume will soon default.";
                
                if (args.alertType == "Watch Zone") {
                    this.alertType = args.alertType + " " + "Entered";
                } else {
                    this.alertType = args.alertType;
                }
                this.contractUnits = args.unit;
                this.alertDate = moment(String(args.alertDate)).format('DD/MM/YYYY');
                this.client = args.clientName;
                this.country = args.stateName;
                this.utility = args.utilityTypeName;
                this.company = args.companyName;
                this.contractName = args.contractName;
                this.contractId = args.contractId;
                this.watchPeriod = args.tradeablePeriodName;
                this.openVolume = args.openVolume;
                this.deafaultDeadlineDate = moment(String(args.deafaultDeadlineDate)).format('DD/MM/YYYY');

                this.$refs.alertDialog.show();
            },
            toolbarClick(args) {
                if (args.item.id.includes('excelexport')) {
                    // hide and show dropdown columns and show text columns as they always have value but dropdowns if not on the page will not have values
                }
                gridOptions.excelExport(args, "Deadline Alert.xlsx", this.$refs);
            },
            excelExportComplete(args) {
                this.$refs.grid.hideSpinner();
                // hide and show dropdown columns and show text columns as they always have value but dropdowns if not on the page will not have values,and return to the state before export
            },

            actionBegin(args) {
                gridOptions.actionBegin(args);
             
            },
            actionComplete(args) {
                gridOptions.actionComplete(args, this.$refs);

                if (args.requestType == "refresh") {

                    if (this.reportContractId != undefined) {
                        apis.protectedApi(`${urls.apiBaseUrl}TriggerAlert/GroupCounts?contractId=${this.reportContractId}`).then(it => {
                            this.deadline = it.data.deadline;
                            this.status = it.data.status;
                            this.hit = it.data.hit;
                            this.AlertsCount = this.hit + this.deadline + this.status;
                            //this is for counter in header, count unseen alerts
                            if (document.getElementsByClassName('expiredTriggerHeader').length > 0) {
                                document.getElementsByClassName('expiredTriggerHeader')[0].innerHTML = "<u>DEFAULT DEADLINES" + " " + this.deadline + "</u>";
                                document.querySelectorAll('[role="presentation"]')[6].innerHTML = "Alerts" + "(" + this.AlertsCount + ")";
                            }
                        });

                    }
                    if (this.clientId != undefined) {
                        apis.protectedApi(`${urls.apiBaseUrl}TriggerAlert/GroupCounts?clientId=${this.clientId}`).then(it => {
                            this.deadline = it.data.deadline;
                            this.status = it.data.status;
                            this.hit = it.data.hit;
                            this.AlertsCount = this.hit + this.deadline + this.status;
                            //this is for counter in header, count unseen alerts
                            if (document.getElementsByClassName('expiredTriggerHeader').length > 0) {
                                document.getElementsByClassName('expiredTriggerHeader')[0].innerHTML = "<u>DEFAULT DEADLINES" + " " + this.deadline + "</u>";
                                document.querySelectorAll('[role="presentation"]')[5].innerHTML = "Alerts" + "(" + this.AlertsCount + ")";
                            }
                        });

                    }
                    if (this.reportTradingGroupId != undefined) {
                        apis.protectedApi(`${urls.apiBaseUrl}TriggerAlert/GroupCountsATG?tradingGroupId=${this.reportTradingGroupId}`).then(it => {
                            this.deadline = it.data.deadline;
                            this.status = it.data.status;
                            this.hit = it.data.hit;
                            this.AlertsCount = this.hit + this.deadline + this.status;
                            //this is for counter in header, count unseen alerts
                            if (document.getElementsByClassName('expiredTriggerHeader').length > 0) {
                                document.getElementsByClassName('expiredTriggerHeader')[0].innerHTML = "<u>DEFAULT DEADLINES" + " " + this.deadline + "</u>";
                                document.querySelectorAll('[role="presentation"]')[6].innerHTML = "Alerts" + "(" + this.AlertsCount + ")";
                            }
                        });
                    }

                }
            },
            actionFailure(args) {
                gridOptions.actionFailure(args);
            },
            customiseCell: function (args) { // when setting up the grid this is rendering each column on its own
                if (args.column.field === 'alertType') {
                    if (args.data['alertType'] == 'Missed') {
                        args.cell.classList.add('redBox');
                    } else {
                        args.cell.classList.add('orangeBox');
                    }
                } else if (args.column.field === 'openVolume') {
                    args.cell.textContent = args.cell.textContent + "%";
                } else if (args.column.headerText === "Actions") {
                    if (args.data['alertStatus'] == 'Seen') {
                        args.cell.querySelector("button[title='Mark as Seen']").textContent = 'Mark as Unseen';
                        args.cell.querySelector("button[title='Mark as Seen']").title = 'Mark as Unseen';
                    }
                }
            },
        },
        provide: {
            grid: [Page, Edit, Toolbar, Sort, Filter, Reorder, Resize, ExcelExport, ForeignKey, CommandColumn],
        }
    };

</script>
<style>
/*    .e-dialog {
        max-height: 900px !important;
        top: 0px !important;
    }*/
    /*@import "../node_modules/@syncfusion/ej2-vue-grids/styles/material.css";*/
    .orangeBox {
        background-color: #d9843b !important;
    }

    .redBox {
        background-color: #f78764 !important;
    }

    .greyBackground {
        background-color: lightgrey;
    }
    #alertDialogDefDeadline .e-dlg-content {
        color: #4d4d4d !important;
    }
    .missedDeadlineHeader {
        text-transform: uppercase;
        color: #f78764 !important;
    }
    .approachingDeadlineHeader {
        text-transform: uppercase;
        color: #7FB7BE !important;
    }
    #deadlineAlertGridId .e-content {
        min-height: 0px!important;
    }
    #alertDialogDefDeadline {
        max-height: 100% !important;
        z-index: 10000 !important;
        position: fixed !important;
        top: 20% !important;
    }

</style>
